import React from "react"

import "./Footer.scss"

const Footer = () => (
  <>
    <footer className="text-center">
      <p id="copyright-text">
        <small>© 2020 Copyright: Wen Ting Wang</small>
      </p>
    </footer>
  </>
)

export default Footer
